import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initSentry } from './lib/sentry';
import { initPlausible } from './lib/analytics';
import './styles/globals.css';

// Initialize error tracking first
initSentry();

// Initialize analytics (non-blocking)
initPlausible();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
// Force rebuild $(date)
// Cache bust: $(date +%s)
